/**
 * Promotions Preview Dialog
 */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  constructHeadline,
  renderDisclaimerContent,
  renderNotesContent,
  renderSubHeadline,
} from '../../pages/createPromotion/service/CreatePromotionService';

const PromotionPreviewDialog = ({ onClose, data }) => {
  const [historicData, setHistoricData] = useState(false);

  useEffect(() => {
    if (data?.headline?.historic || data?.disclaimer?.historic) {
      setHistoricData(true);
    }
  }, [data]);

  const headline = constructHeadline(data, data?.flip, data?.conjunction);
  const disclaimerData = data?.disclaimer;

  // Extract nested ternary into independent statement
  const getDisplayHeadline = () => {
    if (historicData) {
      return constructHeadline(data);
    }

    if (headline?.length) {
      return headline;
    }

    return '[Please Select an HEADLINE]';
  };

  return (
    <Dialog open onClose={onClose} scroll="paper">
      <DialogTitle>
        Promotion Preview ({data.start_date} to {data.end_date})
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="h6" component="h6">
          {getDisplayHeadline()}
        </Typography>
        <br />
        {data?.sub_headline?.FINANCE?.length > 0 && (
          <div>
            <h4>Subheadline</h4>
            {renderSubHeadline(data?.sub_headline?.FINANCE, data?.flip)}
            <br />
          </div>
        )}
        {!!data?.notes && renderNotesContent(data?.notes)}
        <h4>Disclaimer</h4>
        {disclaimerData !== null && renderDisclaimerContent(disclaimerData, data?.flip)}
      </DialogContent>
    </Dialog>
  );
};

// Add PropTypes validation for the component
PromotionPreviewDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  data: PropTypes.shape({
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    headline: PropTypes.shape({
      historic: PropTypes.bool,
    }),
    disclaimer: PropTypes.shape({
      historic: PropTypes.bool,
    }),
    notes: PropTypes.string,
    flip: PropTypes.bool,
    conjunction: PropTypes.string,
    sub_headline: PropTypes.shape({
      FINANCE: PropTypes.array,
    }),
  }).isRequired,
};

export default PromotionPreviewDialog;
